import { prettifyRut } from 'react-rut-formatter'
import React from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { useField } from 'formik'

const InputTextRut = (props) => {
  const [field, meta, helper] = useField(props)

  return (
    <Form.Group controlId={`form-${props.name}`}>
      <Form.Label>{props.label}</Form.Label>
      <InputGroup hasValidation>
        <Form.Control
          type='text'
          placeholder=''
          aria-describedby='inputGroupPrepend'
          name={props.name}
          value={field.value}
          onChange={(e) => {
            const formatted = prettifyRut(e.target.value.toString())
            helper.setValue(formatted)
          }}
          isValid={field.value !== '' && !meta.error && meta.touched}
          isInvalid={!!meta.error}
          {...props}
        />
        <Form.Control.Feedback type='invalid'>
          {meta.error}
        </Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  )
}

export default InputTextRut
